export default __webpack_public_path__ + "static/media/Square-coil-assembly.70c36e81.jpg";